// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "bff1253";
